var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b8b33a65-91b2-4df5-9090-4b380f1b470e",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a0c3678c-4e63-4ec7-93c0-d3863a48719f,.b3632677-1bbf-426f-bcef-e2e4e744b5c1{fill:none;}.afe0db7e-f3fe-46e0-a8b7-990fc728f52e,.b3632677-1bbf-426f-bcef-e2e4e744b5c1{stroke:#8e8e8e;stroke-width:2px;}.a0c3678c-4e63-4ec7-93c0-d3863a48719f,.afe0db7e-f3fe-46e0-a8b7-990fc728f52e,.b3632677-1bbf-426f-bcef-e2e4e744b5c1{stroke-linecap:round;stroke-linejoin:round;}.ae09cd61-2a9e-44eb-bf3e-a30f7d7ee1bf,.afe0db7e-f3fe-46e0-a8b7-990fc728f52e{fill:#8c5fd7;}.e19eec91-5b6e-4c1c-87e6-61480cedce7b{fill:#fff;}.a0c3678c-4e63-4ec7-93c0-d3863a48719f{stroke:#645346;stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b3632677-1bbf-426f-bcef-e2e4e744b5c1",
    d: "M21.3,79.2a4.3,4.3,0,0,0,4.3,4.3H68a4.3,4.3,0,0,0,4.3-4.3V20.8A4.3,4.3,0,0,0,68,16.5H36.3l-15,15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "afe0db7e-f3fe-46e0-a8b7-990fc728f52e",
    d: "M21.3,31.5H32a4.3,4.3,0,0,0,4.3-4.3V16.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ae09cd61-2a9e-44eb-bf3e-a30f7d7ee1bf",
    x: 32.2,
    y: 59.9,
    width: 46.5,
    height: 15.52,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e19eec91-5b6e-4c1c-87e6-61480cedce7b",
    d: "M47.3,69.8l-1.1,3.3H44.8l3.6-10.4H50l3.6,10.4H52.1L51,69.8Zm3.4-1-1-3a18,18,0,0,1-.5-1.9h-.1a12.1,12.1,0,0,1-.5,1.8l-1,3.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e19eec91-5b6e-4c1c-87e6-61480cedce7b",
    d: "M56.6,73.1,53.2,62.7h1.4l1.6,5.1q.8,2.1,1.2,3.9h0q.5-1.8,1.2-3.9l1.8-5.1h1.4L58.1,73.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e19eec91-5b6e-4c1c-87e6-61480cedce7b",
    d: "M64.3,62.7V73.1H62.9V62.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a0c3678c-4e63-4ec7-93c0-d3863a48719f",
    d: "M51.6,35.8H37.3a2.4,2.4,0,0,0-2.4,2.4V52.4a2.4,2.4,0,0,0,2.4,2.4H51.6A2.4,2.4,0,0,0,54,52.4V38.2a2.4,2.4,0,0,0-2.4-2.4ZM61,37.7l-5.5,3.7v7.8L61,52.9a1.6,1.6,0,0,0,2.5-1.2V38.9A1.6,1.6,0,0,0,61,37.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvi);
export default __webpack_public_path__ + "static/media/avi.393966cd8a27bd797bb1c76cbb9daaaf.svg";
export { ForwardRef as ReactComponent };